<template>
  <div>
    <DatosSede
      :direccion="establecimiento.sedes[0].direccion.calle"
      :coordenadas="establecimiento.sedes[0].direccion.coordenadas.coordinates"
      :region="establecimiento.sedes[0].direccion.region"
      :comuna="establecimiento.sedes[0].direccion.comuna"
      :telefono="establecimiento.telefono"
      :paginaWeb="establecimiento.url ? establecimiento.url : 'Sin información'"
    />
    <div class="mt-3">
      <VacantesPrincipal
        v-if="mostrarVacantes"
        :datos="establecimiento.sedes[0]"
        :sedeUnica="establecimiento.sedes.length > 1 ? false : true"
      />
      <VacantesSedes
        v-if="mostrarVacantes"
        :datos="
          establecimiento.sedes.length > 1 ? establecimiento.sedes.slice(1) : []
        "
      />
    </div>
  </div>
</template>

<script>
import DatosSede from "@/components/ficha/derecha/DatosSede";
import VacantesPrincipal from "@/components/ficha/derecha/VacantesPrincipal";
import VacantesSedes from "@/components/ficha/derecha/VacantesSedes";
export default {
  components: {
    DatosSede,
    VacantesPrincipal,
    VacantesSedes
  },
  props: {
    establecimiento: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      mostrarVacantes: ""
    };
  },
  created() {
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };
    this.mostrarVacantes = obtenerValorLocalStorage("mostrarVacantes");
    if (parseInt(this.mostrarVacantes) === 1) {
      this.mostrarVacantes = true;
    } else {
      this.mostrarVacantes = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ficha/UbicacionContactosVacantes.vue